
export const CREATE_PBX = "CREATE_PBX"
export const CREATE_PBX_SUCCESS = "CREATE_PBX_SUCCESS"
export const CREATE_PBX_FAIL = "CREATE_PBX_FAIL"
export const RESET_MESSAGE = "RESET_MESSAGE"
export const RESET_MESSAGE_ERROR = "RESET_MESSAGE_ERROR"
